<div class="overlay">
    <div class="overlay__inner">
        <div class="overlay__content"><span class="prepare-text headline-font">PREPARING THINGS ...</span></div>
    </div>
</div>